import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedProjectResources } from 'store/resources/selectors/resources.selectors';
import { orderBy } from 'lodash';

const selectInteractionsState = (state) => state.interactions;

export const selectTargetGroupedInteractions = createSelector(
  [selectInteractionsState],
  (state) => state.targetGroupedInteractions
);

export const selectTargetInteractions = createSelector(
  [selectTargetGroupedInteractions, (_, target) => target],
  (targetGroupedInteractions, target) => {
    return targetGroupedInteractions[target];
  }
);
export const selectTargetInteractionsEmojisWithJoinedUser = createSelector(
  [
    selectTargetGroupedInteractions,
    selectSelectedProjectResources,
    (_, target) => target,
  ],
  (targetGroupedInteractions, resources, target) => {
    const targetInteractions = targetGroupedInteractions[target];
    if (targetInteractions) {
      return orderBy(
        targetInteractions
          .filter((interaction) => interaction.contentType === 'EMOJI')
          .map((interaction) => {
            const user = resources.find(
              (resource) => resource.user === interaction.userId
            );
            return { ...interaction, user: user };
          }),
        [(interaction) => interaction.createdAt],
        ['asc']
      );
    } else {
      return [];
    }
  }
);

export const selectTargetInteractionsCommentsWithJoinedUser = createSelector(
  [
    selectTargetGroupedInteractions,
    selectSelectedProjectResources,
    (_, target) => target,
  ],
  (targetGroupedInteractions, resources, target) => {
    const targetInteractions = targetGroupedInteractions[target];
    if (targetInteractions) {
      return orderBy(
        targetInteractions
          .filter((interaction) => interaction.contentType === 'COMMENT')
          .map((interaction) => {
            const user = resources.find(
              (resource) => resource.user === interaction.userId
            );
            return { ...interaction, user: user };
          }),
        [(interaction) => interaction.createdAt],
        ['desc']
      );
    } else {
      return [];
    }
  }
);

export const selectTargetInteractionsCommentsAndEmojisWithJoinedUser =
  createSelector(
    [
      selectTargetGroupedInteractions,
      selectSelectedProjectResources,
      (_, target) => target,
    ],
    (targetGroupedInteractions, resources, target) => {
      const targetInteractions = targetGroupedInteractions[target];
      if (targetInteractions) {
        return orderBy(
          targetInteractions
            .filter(
              (interaction) =>
                interaction.contentType === 'COMMENT' ||
                interaction.contentType === 'EMOJI'
            )
            .map((interaction) => {
              const user = resources.find(
                (resource) => resource.user === interaction.userId
              );
              return { ...interaction, user: user };
            }),
          [(interaction) => interaction.createdAt],
          ['desc']
        );
      } else {
        return [];
      }
    }
  );
